export default __webpack_public_path__ + "static/media/nav.7f474e11.svg";